import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

export default gql`
  mutation SubmitEdd($eddResponseInput: [EddResponseInput!]!) {
    submitEddResponse(input: { responses: $eddResponseInput }) {
      __typename
      ... on SubmitEddResponseSuccess {
        message
      }
      ... on SubmitEddResponseError {
        ...error
      }
    }
  }
  ${error}
`;
